import { InputAdornment } from '@mui/material';
import React, { FC } from 'react';
import { FormNumberField } from '../FormNumberField';
import { IFormCurrencyFieldProps } from './types';

export const FormCurrencyField: FC<IFormCurrencyFieldProps> = React.forwardRef(
  (
    { textFieldProps, name, rules, numericFormatProps, defaultValue = '', className, shouldShowAdornment = false },
    ref,
  ) => {
    return (
      <FormNumberField
        defaultValue={defaultValue}
        name={name}
        rules={rules}
        numericFormatProps={{
          decimalScale: 2,
          fixedDecimalScale: true,
          allowNegative: false,
          ...numericFormatProps,
        }}
        className={className}
        shouldShowAdornment={shouldShowAdornment}
        textFieldProps={{
          ...textFieldProps,

          size: 'small',
          inputProps: { min: 1 },
          InputProps: {
            ref,
            startAdornment: <InputAdornment position={'start'}>£</InputAdornment>,
            placeholder: textFieldProps?.placeholder,
            endAdornment: (
              <div className={'font-satoshiMedium ml-2 mt-px whitespace-nowrap font-medium'}>
                {textFieldProps?.InputProps?.endAdornment}
              </div>
            ),
          },
        }}
      />
    );
  },
);

FormCurrencyField.displayName = 'FormCurrencyField';
